import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Icon, Text } from '@adc/ui-core'
import classNames from 'classnames/bind'
import styles from './styles.scss'
const cx = classNames.bind(styles)

class Title extends Component {
  static propTypes = {
    subContent: PropTypes.string,
    mainContent: PropTypes.string,
    onToggle: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    elmId: PropTypes.string,
    sideContent: PropTypes.string,
    removeable: PropTypes.bool,
    useWhiteSpaceTitle: PropTypes.bool,
    /**
     * This is intended to allow opened property to be controlled from outside,
     * but not mandatory for all clients of this component.
     * If a value is passed from outside will rule over the state value
     */
    opened: PropTypes.bool,
  }

  static defaultProps = {
    subContent: '',
    mainContent: '',
    sideContent: '',
    isDarkerTitle: false,
    removeable: false,
    opened: null,
    elmId: 'title',
  }

  state = {
    opened: true,
  }

  onClickIcon = () => {
    const { opened } = this.state
    this.setState({ opened: !opened }, this.props.onToggle)
  }

  render() {
    const {
      elmId,
      subContent,
      mainContent,
      onClose,
      sideContent,
      removeable,
      useWhiteSpaceTitle,
    } = this.props
    const isOpened =
      this.props.opened == null ? this.state.opened : this.props.opened
    const onClickIcon = this.onClickIcon

    return (
      <div className={cx('title', { 'darker-title': useWhiteSpaceTitle })}>
        <div
          className={cx(
            useWhiteSpaceTitle && 'title-background',
            'title-action',
            'title-toggle'
          )}
          onClick={onClickIcon}
        >
          <Icon
            className={cx('icon-toggle', { 'icon-close': !isOpened })}
            name='chevron down'
            color='inherit'
            size='large'
            data-elm-id={`${elmId}_chevron_down_icon`}
          />
        </div>
        <div className={cx('title-text', useWhiteSpaceTitle && 'u-pl-1')}>
          <div className={cx('sub-content')}>{subContent}</div>
          <div className={cx('main-content')}>
            <Text
              size='large'
              weight='heavy'
              className={cx('main-content-text')}
            >
              {mainContent}
            </Text>
          </div>
        </div>
        {sideContent && <div className={cx('side-text')}>{sideContent}</div>}
        <div className={cx('title-action', 'title-close')} onClick={onClose}>
          {!removeable && (
            <Icon
              name='times'
              color='inherit'
              data-elm-id={`${elmId}_close_icon`}
              size='large'
              iconStyle='regular'
            />
          )}
        </div>
      </div>
    )
  }
}

const SimpleTitle = ({ title }) => {
  return (
    <div className={cx('simple-title', 'title')}>
      <div className={cx('title-ribbon')}>
        <Icon
          name='file-contract'
          color='inherit'
          size='big'
          iconStyle='solid'
        />
      </div>
      <div className={cx('title-text')}>
        <div className={cx('sub-content')}>Parent Entity</div>
        <div className={cx('main-content')}>
          <Text size='large' weight='heavy' className={cx('main-content-text')}>
            {title}
          </Text>
        </div>
      </div>
    </div>
  )
}

SimpleTitle.propTypes = {
  title: PropTypes.string,
}

export default Title
export { SimpleTitle }
